import useProfessionalService from '@/hooks/useProfessionalService';
import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SERVICE_LABELS, recordServiceType } from "@/serviceTypes";
import {useArtistTasks} from '@/components/ArtistTasksState';
import {useProfessionalBookings} from '@/components/ProfessionalBookingsState';

export default function ProfessionalServiceNav() {
  useUiLanguage();
  const auth=useAuth(),{workspace}=auth,location=useLocation(),navigate=useNavigate();
  const active=useProfessionalService(auth,location.search);
  const tasks = useArtistTasks(), bookings = useProfessionalBookings();
  if(workspace?.role!=="artist")return null;
  const types=workspace.service_types||["tattoo"],primary=workspace.primary_service_type||types[0];
  if(types.length<2)return null;
  const choose=(value)=>{const query=new URLSearchParams(location.search);query.set("service_type",value);navigate({pathname:location.pathname,search:query.toString()});};
  const unavailable = tasks.error || bookings.error;
  return <div><nav aria-label={tr("Attività professionali")} className="my-3 flex flex-wrap gap-2">{[primary,...types.filter(t=>t!==primary)].map(type=>{
    const count = [...tasks.items, ...bookings.items].filter(item=>recordServiceType(item)===type).length;
    return <button type="button" key={type} aria-pressed={type===active} onClick={()=>choose(type)} className={`flex min-h-11 items-center gap-2 rounded-full border px-3 py-2 text-sm ${active===type?"bg-primary text-primary-foreground":"bg-card"}`}>
      <span>{SERVICE_LABELS[type]}{type===primary?tr(" · principale"):""}</span>
      {count>0&&<span className="rounded-full border border-current px-1.5 text-xs font-semibold" aria-label={tr('{{0}} attività da gestire', {0:count})}>{count}</span>}
    </button>;
  })}</nav>{unavailable&&<p role="status" className="text-xs text-muted-foreground">{tr('Conteggi da aggiornare. Riprova.')} <button type="button" className="rounded border px-2 py-1" onClick={()=>window.dispatchEvent(new Event('tps:data-changed'))}>{tr('Riprova')}</button></p>}</div>;
}

